import plugLeadLogo from '@assets/logo/partners/plug-lead.png';
import activeCampaignLogo from '@assets/logo/partners/activecampaign.png';

export const PLATFORMS = {
    pluglead: {
        key: 'pluglead',
        name: 'PlugLead',
        logo: plugLeadLogo,
    },
    activecampaign: {
        key: 'activecampaign',
        name: 'ActiveCampaign',
        logo: activeCampaignLogo,
    },
    manual: {
        key: 'manual',
        name: 'Manual',
        logo: null,
    },
};

export const EVENTS = {
    'payments.confirmed': 'Pagamento confirmado',
    'payments.pix_generated': 'Pix gerado',
    'payments.checkout_dropped': 'Checkout abandonado',
};
